import type { DocumentTypeEnum } from 'models/enums/documentTypeEnum';

export function getDocumentTypeName(type: DocumentTypeEnum): string {
  const names = ['pdf', 'docx'] as const;

  return names[type];
}

export function getDocumentTypeExt(type: DocumentTypeEnum, widthDot = true): string {
  const names = ['pdf', 'docx'] as const;

  return `${widthDot ? '.' : ''}${names[type]}`;
}
